export const DEFAULT_META_STATE: MetaState = {};

export interface MetaState {
  userDisplayName?: string;
  userPhotoUrl?: string;
}
